import { render, staticRenderFns } from "./index.vue?vue&type=template&id=367c7b2e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=367c7b2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367c7b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('367c7b2e')) {
      api.createRecord('367c7b2e', component.options)
    } else {
      api.reload('367c7b2e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=367c7b2e&scoped=true", function () {
      api.rerender('367c7b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/landingPage/index.vue"
export default component.exports